// extracted by mini-css-extract-plugin
export default {"game_container":"memory-card-game_game_container__tVw6f"};